export default "__VITE_ASSET__C0s0u0Fr__"